import { render } from "./ProfileTierLayout.vue?vue&type=template&id=4d316131"
import script from "./ProfileTierLayout.vue?vue&type=script&lang=js"
export * from "./ProfileTierLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__